import { storyblokEditable } from "gatsby-source-storyblok"

import ArticleParagraph from "@components/V2/Lab/ArticleParagraph"
import React from "react"

const ArticleParagraphStoryblok = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ArticleParagraph>) => {
  return (
    <ArticleParagraph
      id={blok.id}
      headerText={blok.headerText}
      content={blok.content}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default ArticleParagraphStoryblok
